module.exports = __webpack_public_path__ + "media/fonts/BrandonGrotesque-Medium-34706d4477fc5af279ffec6fd128448f.ttf";